angular.module('app.broadcastStatus.broadcastStatusListService', [])
  .factory('app.broadcastStatus.broadcastStatusListService', [
    '$http',
    function ($http) {
      "use strict";
      
      let service = {
        list: null,
        error: null,
        isLoading: true,

        retrieve: function () {

          service.list = null;
          service.error = null;
          service.isLoading = true;

          return $http.get(window.location.api('games_status'))
            .then(
              function (response) {

                let data = response.data;
                service.list = null;

                if (data.error) {
                  service.error = data.error;
                }

                if (data.length) {
                  service.list = data;
                }

                service.isLoading = false;
              },
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                let data = response.data;

                if (data && data.error) {
                  service.error = data.error;
                }
                else {
                  service.error = 'Failed to retrieve broadcast status listing.'
                }

                service.isLoading = false;
              }
            );
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/broadcastStatus/broadcastStatusListService.js